import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { CustomLabelStore } from '../service/custom-label.store';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { User } from '../../auth/models/User';
import { CustomLabelResponse } from '../models/custom-label-response';
import { CustomLabelRequest } from '../models/custom-label-request';
import { EventStore } from '../service/event.store';
import { MultiAgencyService } from '../../shared/multi-agency/multi-agency.service';
import { EventResolver } from '../event/event.resolver';
import { OnyxEvent } from '../models/event';

@Injectable()
export class CustomLabelResolver implements Resolve<any> {

  private user: User = null;
  private agencyId: string = null;

  constructor(private customLabelStore: CustomLabelStore,
              private eventStore: EventStore,
              private authenticationStore: AuthenticationStore,
              private multiAgencyService: MultiAgencyService,
              private eventResolver: EventResolver) {
    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });

    this.multiAgencyService.defaultAgencyId.subscribe((agencyId: string) => {
      this.agencyId = agencyId;
    });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<CustomLabelResponse> {
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!eventPartyId) {
      // Preload labels when user is single property user or agency
      return this.loadDefaultLabels();
    } else {
      const eventId = route.params['id'];
      return this.eventStore.getEventByParty(eventId, eventPartyId).flatMap((event: OnyxEvent) => {
        const request = new CustomLabelRequest({
          chainCode: event.eventProperty.chain,
          brandCode: event.eventProperty.brand,
          propertyId: event.eventProperty.propertyId
        });
        return this.customLabelStore.loadCustomLabels(request);
      });
    }
  }

  loadDefaultLabels(): Observable<CustomLabelResponse> {
    if (this.authenticationStore.isPropertyUser()) {
      const request = new CustomLabelRequest({
        chainCode: this.user.allChains[0],
        brandCode: this.user.allBrands && this.user.allBrands.length > 0 ? this.user.allBrands[0] : null,
        propertyId: this.authenticationStore.isSinglePropertyUser() ? this.user.allProperties[0] : null
      });
      return this.customLabelStore.loadCustomLabels(request);
    } else if (this.authenticationStore.isAgencyUser()) {
      const customerInfo = this.user.customerInfo.filter((value) => value.includes(this.agencyId));
      const request = new CustomLabelRequest({
        customerNum: customerInfo && customerInfo.length > 0 ? customerInfo[0].substring(0, customerInfo[0].indexOf('#')) : null,
        iata: this.agencyId
      });
      return this.customLabelStore.loadCustomLabels(request);
    }
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/basic-event-data/custom-label.resolver.ts